module.exports = __webpack_public_path__ + "static/img/Maple Porcini.92c8b50.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Maple Porcini.jpg
// module id = G8MW
// module chunks = 0